import {styled} from '@esgi/ui/theme';
import {AsyncHighchartsReact} from '@esgi/deprecated/highcharts';

export const Chart = styled(AsyncHighchartsReact, {
	width: 80,
});
